import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { HelperService } from '../shared/services/helper.service';
import { catchError, Subscription, take, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { SidebarService } from '../shared/services/sidebar.service';
import { HttpService } from '../shared/services/http.service';
import { PageMetadataService } from '../shared/services/page-metadata.service';
import { HomeService } from '../home/home.service';
import { formatDate } from '../utility';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrl: './my-tasks.component.css',
})
export class MyTasksComponent implements OnInit, OnDestroy {
  myTaskUrl=`${environment.opbBackendHost}/api/member/my/tasks`
  cloneModal: boolean = false;
  isTask: boolean = true;
  isMytask: boolean = true;
  brandListSubs!: Subscription;
  themeListSubs!: Subscription;
  memberListSubs!: Subscription;
  wpListSubs!: Subscription;
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  httpService = inject(HttpService);
  pageMetaData = inject(PageMetadataService);

  homeService = inject(HomeService);
  sidebarService = inject(SidebarService);
  helper = inject(HelperService);
  quarterlyOutcomesLists: any = [];
  // quarterlyOutcomes = [
  //   {
  //     name: 'Develop a New Product Vision',
  //     milestoneCount: 5,
  //   },
  //   {
  //     name: 'Launch new tool successfully',
  //     milestoneCount: 4,
  //   },
  //   {
  //     name: 'Quarterly Outcome 3',
  //     milestoneCount: 3,
  //   },
  // ];

  searchTerm: string = '';
  isLoading: boolean = false;
  wpLists: any;
  brandLists: any;
  businessThemeLists: any;
  teamMembersLists: any;
  isSidebarOpen: boolean = false;
  filterCount: number = 0;
  currentYear: any;
  quarter: any = [];
  apiService = inject(ApiService);
  roleSubscription: Subscription;
  quaterSubscription: Subscription;
  myTasksData: any;

  filterQuarterlyOutcomes() {
    let data = {
      search: this.searchTerm.toLowerCase(),
    };
    this.fetchquarterlyOutcomesLists(data);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  myTaskSelection(filterData: any) {
    this.searchTerm = '';
    this.filterCount = this.getFilledPropertiesCount(filterData);
    this.fetchquarterlyOutcomesLists(filterData);
  }

  getFilledPropertiesCount(data: any) {
    return Object.keys(data).filter(
      (key) => data[key] !== null && data[key] !== '' && data[key] != undefined
    )?.length;
  }

  ngOnInit() {
    this.sidebarService.cleanTaskSelection();
    this.pageMetaData.setTitle('My-Tasks | OBP');
    this.helper.isOutcomeDataLoad$.subscribe((res: any) => {
      if (res) {
        this.handleChildEvent();
      }
    });
    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.fetchCurrentYear(data);
    });

    // this.sidebarService.cleanTaskSelection();
    this.wpListSubs = this.helper.wpList$.subscribe((data: any) => {
      this.wpLists = data;
    });
    this.brandListSubs = this.helper.brandList$.subscribe((data: any) => {
      this.brandLists = data;
    });
    this.themeListSubs = this.helper.themeList$.subscribe((data: any) => {
      this.businessThemeLists = data;
    });
    this.memberListSubs = this.helper.memberList$.subscribe((data: any) => {
      this.teamMembersLists = data;
    });

    // this.quaterSubscription = this.apiService.quarter$.subscribe((currentQuater) => {
    //   this.sidebarService.myTasksData.quarter=currentQuater
    //   this.sidebarService.myTasksData.year=new Date().getFullYear()
    //   this.myTaskSelection({...this.sidebarService?.myTasksData});
    // });

    this.quaterSubscription = this.apiService.quarter$
      .subscribe((currentQuater) => {
        if(currentQuater){
          this.sidebarService.myTasksData.quarter = currentQuater;
        this.sidebarService.myTasksData.year = new Date().getFullYear();
        this.myTaskSelection({ ...this.sidebarService?.myTasksData });
        }
        
      });

    // this.fetchquarterlyOutcomesLists();
    this.breadCrumbItems = [{ label: 'To-Do' }, { label: 'My Tasks' }];

    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };
  }

  cloneQuarterlyOutcomes() {
    this.cloneModal = true;
  }

  handleChildEvent(event?: any) {
    this.fetchquarterlyOutcomesLists();
  }

  fetchquarterlyOutcomesLists(task?: any) {
    this.myTasksData={
      ...this.sidebarService.myTasksData,
      search: task?.search || '',
    }
    this.isLoading = true;
    let data = {
      search: task?.search || '',
      ...task,
      ...this.sidebarService.myTasksData
    };
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/my/tasks`, data)
      .pipe(
        catchError((error) => {
          console.error('Error occurred:', error);
          this.isLoading = false;
          return throwError(() => error);
        })
      )
      .subscribe((res: any) => {
        this.quarterlyOutcomesLists = res?.data;
        this.isLoading = false;
      });
  }

  onDataLoaded(data: any[]) {
    this.quarterlyOutcomesLists = data;
  }

  fetchCurrentYear(cat: any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/year`, {})
      .subscribe((res: any) => {
        this.currentYear = res?.data;
        this.quarterList(cat);
      });
  }

  quarterList(cat: string) {
    const data = {
      year: this.currentYear,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  ngOnDestroy(): void {
    this.roleSubscription?.unsubscribe();
    this.wpListSubs?.unsubscribe();
    this.brandListSubs?.unsubscribe();
    this.themeListSubs?.unsubscribe();
    this.memberListSubs?.unsubscribe();
    this.sidebarService.cleanTaskSelection();
    this.quaterSubscription.unsubscribe();
  }
}
